/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateJournalSupportRequest
 */
export interface CreateJournalSupportRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateJournalSupportRequest
     */
    endTimeUtc: Date;
}

/**
 * Check if a given object implements the CreateJournalSupportRequest interface.
 */
export function instanceOfCreateJournalSupportRequest(value: object): value is CreateJournalSupportRequest {
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    return true;
}

export function CreateJournalSupportRequestFromJSON(json: any): CreateJournalSupportRequest {
    return CreateJournalSupportRequestFromJSONTyped(json, false);
}

export function CreateJournalSupportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateJournalSupportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endTimeUtc': (new Date(json['endTimeUtc'])),
    };
}

export function CreateJournalSupportRequestToJSON(json: any): CreateJournalSupportRequest {
    return CreateJournalSupportRequestToJSONTyped(json, false);
}

export function CreateJournalSupportRequestToJSONTyped(value?: CreateJournalSupportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endTimeUtc': value['endTimeUtc'].toISOString(),
    };
}

